export function ErrorBadge({ children }: { children: React.ReactNode | React.ReactNode[] | string }) {
    return (
        <div className="rounded-lg bg-red-50 px-2 py-2 text-sm font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
            {children}
        </div>
    );
}
